import(/* webpackMode: "eager" */ "/home/runner/work/kabox-frontend/kabox-frontend/app/[locale]/login/page.jsx");
